/**
 * Calculates the mean (average) of an array of numbers.
 *
 * @param {Array<number>} arr - The array of numbers.
 * @returns {number} - The mean of the numbers.
 */
export function mean(arr) {
    const sum = arr.reduce((a, b) => a + b, 0);
    return sum / arr.length;
}

/**
 * Calculates the median of an array of numbers.
 *
 * @param {Array<number>} arr - The array of numbers.
 * @returns {number} - The median of the numbers.
 */
export function median(arr) {
    const sortedArr = arr.slice().sort((a, b) => a - b);
    const mid = Math.floor(sortedArr.length / 2);
    if (sortedArr.length % 2 === 0) {
        return (sortedArr[mid - 1] + sortedArr[mid]) / 2;
    } else {
        return sortedArr[mid];
    }
}

/**
 * Calculates the mode of an array of numbers.
 *
 * @param {Array<number>} arr - The array of numbers.
 * @returns {number} - The mode of the numbers.
 */
export function mode(arr) {
    const frequency = {};
    let maxFreq = 0;
    let mode;

    for (const num of arr) {
        frequency[num] = (frequency[num] || 0) + 1;
        if (frequency[num] > maxFreq) {
            maxFreq = frequency[num];
            mode = num;
        }
    }

    return mode;
}